import React, { PureComponent } from 'react'
import MdFormatPaint from 'react-icons/lib/md/format-paint'
import { string, func } from 'prop-types'
import { connect } from 'react-redux'
import { Div } from '../styles/ColorScheme'
import { TwitterPicker } from 'react-color'
import MdClose from 'react-icons/lib/md/close'
import { changeTheme } from '../../../../store/Actions/SpiActions'
import { Colors } from './Colors'
import { enableColorPicker } from '../../../../config'

class ColorScheme extends PureComponent {
  state = {
    showPicker: false,
  }

  handleChange = e => {
    this.props.changeTheme(e.hex)
    this.setState({ showPicker: false })
  }

  render() {
    return enableColorPicker ? (
      <li>
        <span>
          <MdFormatPaint color={this.props.theme} />
          Color Scheme
        </span>

        <Div
          theme={this.props.theme}
          onClick={() => this.setState({ showPicker: !this.state.showPicker })}
        >
          {this.state.showPicker && <MdClose color="white" />}
        </Div>
        {this.state.showPicker && (
          <TwitterPicker
            triangle="hide"
            onChange={this.handleChange}
            colors={Colors()}
          />
        )}
      </li>
    ) : null
  }
}

ColorScheme.propTypes = {
  theme: string.isRequired,
  changeTheme: func.isRequired,
}

const mapStateToProps = ({ spi }) => ({
  theme: spi.theme,
})

const mapDispatchToProps = dispatch => ({
  changeTheme: value => dispatch(changeTheme(value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ColorScheme)



// WEBPACK FOOTER //
// ./src/components/Elements/Sidebar/Settings/ColorScheme.jsx